import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavigationComponent } from './header-navigation/navigation.component';
import { CardComponent } from './card/card.component';

@NgModule({
  declarations: [
    BreadcrumbComponent,
    SidebarComponent,
    NavigationComponent,
    CardComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports : [
    BreadcrumbComponent,
    SidebarComponent,
    NavigationComponent,
    CardComponent
  ]
})
export class SharedModule { }
